import { Helmet } from 'react-helmet-async';
import { useSiteData } from '@/hooks/useSiteData';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { Hero } from '@/components/sections/Hero';
import { About } from '@/components/sections/About';
import { Testimonials } from '@/components/sections/Testimonials';

export function Index() {
  const { siteData } = useSiteData();

  return (
    <>
      <Helmet>
        <title>{siteData.title}</title>
        <meta name="description" content={siteData.description} />
        <meta name="keywords" content={siteData.keywords} />
        
        {/* Canonical URL */}
        <link rel="canonical" href="https://www.atlastulsa.com" />
        
        {/* Open Graph Tags */}
        <meta property="og:site_name" content={siteData.title} />
        <meta property="og:title" content={siteData.title} />
        <meta property="og:url" content="https://www.atlastulsa.com" />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={siteData.description} />
        <meta property="og:image" content="http://static1.squarespace.com/static/6644d38ed4adce7ffd20a16a/t/67760b7d7627f906663a6566/1735789443913/atlas+sign.png?format=1500w" />
        <meta property="og:image:width" content="768" />
        <meta property="og:image:height" content="768" />
        
        {/* Twitter Card Tags */}
        <meta name="twitter:title" content={siteData.title} />
        <meta name="twitter:image" content="http://static1.squarespace.com/static/6644d38ed4adce7ffd20a16a/t/67760b7d7627f906663a6566/1735789443913/atlas+sign.png?format=1500w" />
        <meta name="twitter:url" content="https://www.atlastulsa.com" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:description" content={siteData.description} />
        
        {/* Schema.org microdata */}
        <meta itemProp="name" content={siteData.title} />
        <meta itemProp="url" content="https://www.atlastulsa.com" />
        <meta itemProp="description" content={siteData.description} />
        <meta itemProp="thumbnailUrl" content="http://static1.squarespace.com/static/6644d38ed4adce7ffd20a16a/t/67760b7d7627f906663a6566/1735789443913/atlas+sign.png?format=1500w" />
        <meta itemProp="image" content="http://static1.squarespace.com/static/6644d38ed4adce7ffd20a16a/t/67760b7d7627f906663a6566/1735789443913/atlas+sign.png?format=1500w" />
        
        {/* Additional SEO */}
        <link rel="image_src" href="http://static1.squarespace.com/static/6644d38ed4adce7ffd20a16a/t/67760b7d7627f906663a6566/1735789443913/atlas+sign.png?format=1500w" />
        
        {/* Structured Data JSON-LD */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "WebSite",
            "url": "https://www.atlastulsa.com",
            "name": siteData.title,
            "image": "//images.squarespace-cdn.com/content/v1/6644d38ed4adce7ffd20a16a/4fd5740b-3cc3-4531-9faf-8014303a402c/Untitled+%283%29.png"
          })}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "http://schema.org",
            "@type": "Organization",
            "legalName": "Atlas Automotive Repair, LLC",
            "address": "4625 East 11th Street\nTulsa, OK, 74112\nUnited States",
            "email": "atlasautomotiverepair@gmail.com",
            "telephone": "(918)910-2886",
            "sameAs": [
              "https://www.instagram.com/atlasautomotive_route66/",
              "https://www.facebook.com/atlasautomotivetulsa",
              "https://maps.app.goo.gl/1wxW1ufFbJPtPw3r7"
            ]
          })}
        </script>
        
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "LocalBusiness",
            "name": "Atlas Automotive Repair, LLC",
            "image": "https://static1.squarespace.com/static/6644d38ed4adce7ffd20a16a/t/6648024f03989e5b287b046c/1735788382564/",
            "telephone": "+1-918-910-2886",
            "email": "atlasautomotiverepair@gmail.com",
            "priceRange": "$",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "4625 East 11th Street",
              "addressLocality": "Tulsa",
              "addressRegion": "OK",
              "postalCode": "74112",
              "addressCountry": "US"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": 36.15398,
              "longitude": -95.93625
            },
            "url": "https://www.atlastulsa.com",
            "openingHoursSpecification": [
              {
                "@type": "OpeningHoursSpecification",
                "dayOfWeek": [
                  "Monday",
                  "Tuesday",
                  "Wednesday",
                  "Thursday",
                  "Friday"
                ],
                "opens": "09:00",
                "closes": "17:00"
              }
            ],
            "sameAs": [
              "https://www.instagram.com/atlasautomotive_route66/",
              "https://www.facebook.com/atlasautomotivetulsa",
              "https://maps.app.goo.gl/1wxW1ufFbJPtPw3r7"
            ],
            "legalName": "Atlas Automotive Repair, LLC"
          })}
        </script>
      </Helmet>
      
      <div className="min-h-screen">
        <Header siteData={siteData} />
        <Hero />
        <About content={siteData.about} />
        <Testimonials data={siteData.testimonials} />
        <Footer siteData={siteData} />
      </div>
    </>
  );
}